const color = ['#00aeef', '#f35958', '#f6d052', '#a763a5', '#fbe0c2'];
export default {
    color: color,
    series: [
        {
            name: '',
            type: 'pie',
            radius: ['35%', '45%'],
            center: ['50%', '50%'],
            zlevel: 1,
            startAngle: 0,
            label: {
                formatter: '{c|{d}%\n{b}}',
                color: '#64fdfd',
                fontSize: 12,
                rich: {
                    c: {
                        align: 'center',
                    }
                }
            },
            labelLine: {
                lineStyle: {
                    cap: 'round'
                }
            },
            data: []
        },
        {
            name: '背景',
            type: 'pie',
            radius: ['45%', '55%'],
            center: ['50%', '50%'],
            label: {
                show: false
            },
            itemStyle: {
                color: {
                    type: 'radial',
                    x: 0.5,
                    y: 0.5,
                    r: 0.5,
                    colorStops: [{
                        offset: 0, color: 'rgba(61, 211, 254, 0)' // 0% 处的颜色
                    },{
                        offset: 0.7, color: 'rgba(61, 211, 254, 0)' // 0% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(61, 211, 254, 0.5)' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                }
            },
            data: [{
                value: 100
            }]
        },
    ]
}
